var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 2508",
  transform: "translate(-583.846 -456)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 297",
  width: 24,
  height: 24,
  rx: 12,
  transform: "translate(583.846 456)",
  fill: "#26b99a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 28",
  d: "M594.594 464.678l.233-3.328-5.348 4.748 4.508 5.794.32-3.138s3.55-.807 6.202 5.03c0 0 2.083-4.213-1.1-7.561a7.603 7.603 0 00-4.815-1.545z",
  fill: "#fff"
}))));
export default __webpack_public_path__ + "static/media/buyback.9ad844f1.svg";
export { SvgComponent as ReactComponent };